module.exports = __webpack_public_path__ + "img/login-dark.7aea10f9.png";